document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.multi-variant-cart');
  if (!container) return;

  // --- Qty button clicks ---
  container.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-action]');
    if (!btn || btn.disabled) return;

    const row = btn.closest('.multi-variant-row');
    if (!row) return;

    const input = row.querySelector('.multi-variant-qty-input');
    const current = parseInt(input.value, 10) || 0;

    if (btn.dataset.action === 'plus') {
      input.value = Math.min(current + 1, 99);
    } else if (btn.dataset.action === 'minus') {
      input.value = Math.max(current - 1, 0);
    }

    syncRowState(row);
    updateButtons(container);
  });

  // --- Direct number input ---
  container.addEventListener('input', function (e) {
    const input = e.target.closest('.multi-variant-qty-input');
    if (!input) return;

    const row = input.closest('.multi-variant-row');
    if (!row) return;

    const raw = parseInt(input.value, 10);
    if (isNaN(raw) || raw < 0) input.value = 0;
    if (raw > 99) input.value = 99;

    syncRowState(row);
    updateButtons(container);
  });

  // --- Add to Cart ---
  const submitBtn = container.querySelector('.multi-variant-cart__submit');
  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      submitToCart(container, { checkout: false });
    });
  }

  // --- Initial state ---
  container.querySelectorAll('.multi-variant-row').forEach(syncRowState);
  updateButtons(container);

  // Show checkout CTAs if cart already has items (persists across navigation)
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart.item_count > 0) {
        showPostAddCtas(container);
      }
    })
    .catch(function () {});
});

function syncRowState(row) {
  const qty = parseInt(row.querySelector('.multi-variant-qty-input').value, 10) || 0;
  row.classList.toggle('multi-variant-row--selected', qty > 0);

  const minusBtn = row.querySelector('[data-action="minus"]');
  if (minusBtn) minusBtn.disabled = qty <= 0;
}

function getSelectedItems(container) {
  const items = [];
  container.querySelectorAll('.multi-variant-row').forEach(function (row) {
    if (row.dataset.variantAvailable !== 'true') return;
    const qty = parseInt(row.querySelector('.multi-variant-qty-input').value, 10) || 0;
    if (qty > 0) {
      items.push({ id: parseInt(row.dataset.variantId, 10), quantity: qty });
    }
  });
  return items;
}

function updateButtons(container) {
  const hasItems = getSelectedItems(container).length > 0;
  const totalQty = getSelectedItems(container).reduce(function (s, i) { return s + i.quantity; }, 0);

  const submitBtn = container.querySelector('.multi-variant-cart__submit');
  const submitText = submitBtn && submitBtn.querySelector('.multi-variant-cart__submit-text');

  if (submitBtn) submitBtn.disabled = !hasItems;

  if (submitText) {
    submitText.textContent = hasItems
      ? 'Add device + ' + totalQty + ' compound' + (totalQty !== 1 ? 's' : '') + ' to Cart'
      : 'Select quantities above';
  }
}

async function submitToCart(container, options) {
  const compoundItems = getSelectedItems(container);
  if (!compoundItems.length) return;

  // Always include the device itself at qty 1
  const deviceVariantId = parseInt(container.dataset.deviceVariantId, 10);
  const items = deviceVariantId
    ? [{ id: deviceVariantId, quantity: 1 }, ...compoundItems]
    : compoundItems;

  const submitBtn = container.querySelector('.multi-variant-cart__submit');
  const submitText = submitBtn && submitBtn.querySelector('.multi-variant-cart__submit-text');

  if (submitBtn) submitBtn.disabled = true;
  if (submitText) submitText.textContent = 'Adding\u2026';

  // Collect section IDs so the cart drawer can re-render itself
  const sectionIds = [];
  document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
    sectionIds.push(el.dataset.sectionId);
  });

  const body = { items: items };
  if (sectionIds.length) {
    body.sections = sectionIds.join(',');
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    const data = await response.json();

    if (data.status) {
      // Shopify returned an error (sold out, over limit, etc.)
      showFeedback(container, data.message || 'Unable to add to cart.', 'error');
      updateButtons(container);
    } else {
      const totalQty = compoundItems.reduce(function (sum, item) { return sum + item.quantity; }, 0);

      // Dispatch the theme's cart:update event so the cart drawer and icon update
      container.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: data,
            sourceId: 'multi-variant-cart',
            data: {
              source: 'multi-variant-cart',
              itemCount: items.reduce(function (s, i) { return s + i.quantity; }, 0),
              sections: data.sections,
            },
          },
        })
      );

      showFeedback(
        container,
        'Device + ' + totalQty + ' compound' + (totalQty !== 1 ? 's' : '') + ' added to cart!',
        'success'
      );

      // Show checkout and view-cart CTAs
      showPostAddCtas(container);

      // Reset all quantity inputs
      container.querySelectorAll('.multi-variant-row').forEach(function (row) {
        row.querySelector('.multi-variant-qty-input').value = '0';
        syncRowState(row);
      });

      updateButtons(container);
    }
  } catch (err) {
    console.error('[multi-variant-cart]', err);
    showFeedback(container, 'Something went wrong. Please try again.', 'error');
    updateButtons(container);
  }
}

function showPostAddCtas(container) {
  container.classList.add('multi-variant-cart--added');
  container.querySelectorAll('.multi-variant-cart__post-add').forEach(function (el) {
    el.removeAttribute('aria-hidden');
  });
}

function showFeedback(container, message, type) {
  const feedback = container.querySelector('.multi-variant-cart__feedback');
  if (!feedback) return;

  feedback.textContent = message;
  feedback.dataset.type = type;

  clearTimeout(feedback._clearTimer);
  feedback._clearTimer = setTimeout(function () {
    feedback.textContent = '';
    delete feedback.dataset.type;
  }, 5000);
}
